import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import BarChart from '../components/CardWithBarChart/components/BarChart';
import Frame from './components/Frame';

function SlbDashboard() {
  const slbFaresState = useSelector((reducer: IReducer) => reducer.slbFares);

  return (
    <Frame.Base isActive={slbFaresState.isActive}>
      <Card
        isActive
        title="SLBs Pagas"
        gridArea="slbPaid"
        display="flex"
        justifyContent="center"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(slbFaresState.slbPaid.value).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="SLBs Pagas nos últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        padding=""
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <BarChart
          data={slbFaresState.lastTwelveMonths}
          hasOneData
          firstValueColor={theme.colors.red}
          secondValueColor={theme.colors.red}
          labelForOneData="Pagas"
          labelForTwoDatas={{
            firstLabel: 'Recebidas     ',
            secondLabel: 'Pagas     ',
          }}
        />
      </Card>
    </Frame.Base>
  );
}

export default SlbDashboard;
